import useToken from 'hooks/useToken';
import React, { useEffect, useState } from 'react';
import { Card, Col, Row, Spinner } from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';
import TablaOrdenes from './TablaOrdenes';
import TablaDetalleOrdenes from './TablaDetalleOrdenes';

const CatalogoOrdenes = () => {
    //AUTENTICACION
    const { token, setToken, idCatTipoUsuario, idUsuario } = useToken();
    const [pageNumber, setPageNumber] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    //datos
    const [ordenes, setOrdenes] = useState([]);
    const [detallesOrdenes, setDetallesOrdenes] = useState([]);
    const [vendedores, setVendedores] = useState([]);
    const [vendedorID, setVendedorID] = useState(idUsuario)
    const [dateQuarter, setDateQuarter] = useState(new Date())
    const [cargando, setCargando] = useState(true);
    const [totalMXN, setTotalMXN] = useState(0);
    const [FilterEstatus, setFilterEstatus] = useState('-1');
    const [tipoReporte, setTipoReporte] = useState(0);
    const [searchFilter, setSearchFilter] = useState('');


    //Obtiene las licencias por id
    const ObtenerDetallesOrden = async (idUsuario, date_, page = 1, currentSize = pageSize, querySearch = searchFilter) => {

        setDateQuarter(new Date(date_));
        var month = new Date(date_).getMonth();
        month = month + 1;
        var year = new Date(date_).getFullYear();
        setVendedorID(idUsuario)

        var iEstatus = FilterEstatus;

        setOrdenes([]);
        setCargando(true);
        const response = await fetch(`/api/orden/ObtenerListaDetallesOrdenes/?idUsuario=${idUsuario}&month=${month}&year=${year}&iEstatus=${iEstatus}&pageNumber=${page}&pageSize=${currentSize}&search=${querySearch}`, {
            method: 'GET',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        })
            .catch((error) => {
                console.log('Hubo un problema con la peticion Fetch:' + error.message);
            });

        if (response.ok) {
            const data = await response.json();
            console.log(data);
            setDetallesOrdenes(data['table1']);

            setTotalMXN(data['table2'][0].totalMXN)

            if (data['table3'] && data['table3'][0]) {
                setTotalRecords(data['table3'][0].totalRecords);
            } else {
                setTotalRecords(0);
            }

        }
        else {
            console.log(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
            console.log(response);
        }
        setCargando(false);

    };


    //Obtiene las licencias por id
    const ObtenerOrden = async (idUsuario, date_, page = 1, currentSize = pageSize, querySearch = searchFilter) => {
 
        setDateQuarter(new Date(date_));
        var month = new Date(date_).getMonth();
        month = month + 1;
        var year = new Date(date_).getFullYear();
        setVendedorID(idUsuario)

        var iEstatus = FilterEstatus;

        setOrdenes([]);
        setDetallesOrdenes([]);
        setCargando(true);
        const response = await fetch(`/api/orden/ObtenerListaOrdenes/?idUsuario=${idUsuario}&month=${month}&year=${year}&iEstatus=${iEstatus}&pageNumber=${page}&pageSize=${currentSize}&search=${querySearch}`, {
            method: 'GET',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            },

        })
            .catch((error) => {
                console.log('Hubo un problema con la peticion Fetch:' + error.message);
            });

        if (response.ok) {
            const data = await response.json();
            console.log(data);
            setOrdenes(data['table1']);
            setVendedores(data['table2'])
            setTotalMXN(data['table3'][0].totalMXN)

            if (data['table4'] && data['table4'][0]) {
                setTotalRecords(data['table4'][0].totalRecords);
            } else {
                setTotalRecords(0);
            }
        }
        else {
            console.log(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
            console.log(response);
        }
        setCargando(false);
    };
    const handleSearchChange = (value) => {
        const limpiar = value ? value.trim() : '';
        setSearchFilter(limpiar);
        setPageNumber(1);
    };

    //ejecutar solo 1 vez despues del DOM
    useEffect(() => {

        var date_ = sessionStorage.getItem("selectMes") == null ? dateQuarter : sessionStorage.getItem("selectMes");
        var idUsuario_ = sessionStorage.getItem("selectIDUsuario") == null ? idUsuario : sessionStorage.getItem("selectIDUsuario");
        if (tipoReporte == 0)
            ObtenerOrden(idUsuario_, date_, pageNumber, pageSize, searchFilter);
        else
            ObtenerDetallesOrden(idUsuario_, date_, pageNumber, pageSize, searchFilter);
    }, [FilterEstatus, tipoReporte, vendedorID, pageNumber, pageSize, searchFilter]);


    return (
        <>
            <Card className="mb-1 p-2">
                <Row className="g-2 align-items-sm-center">
                    <Col xs="auto">
                        <img src="/img/ordenes96.png" alt="connectCircle" height={30} />
                    </Col>
                    <Col>
                        <h5>
                            Cat&aacute;logo de &oacute;rdenes
                        </h5>
                    </Col>

                    <Col sm="auto" className="ms-auto">
                        {idCatTipoUsuario == 1 && <>
                            <img src="/img/dinero48.png" width="32"></img>&nbsp;

                            <span className={
                                'font-sans-serif fs-1 ' + (totalMXN > 0 ? 'text-success' : 'text-danger')
                            }>
                                {cargando ? <Skeleton className="w-75" /> : <strong>${parseFloat(totalMXN).toLocaleString("es-MX", {
                                    maximumFractionDigits: 2,
                                    minimumFractionDigits: 2
                                })} MXN</strong>}
                            </span></>
                        }

                    </Col>
                </Row>
            </Card>

            {tipoReporte === 0 ? (
                <TablaOrdenes
                    ordenes={ordenes}
                    vendedores={vendedores}
                    vendedorID={vendedorID}
                    setVendedorID={setVendedorID}
                    dateQuarter={dateQuarter}
                    setDateQuarter={setDateQuarter}
                    FilterEstatus={FilterEstatus}
                    setFilterEstatus={setFilterEstatus}
                    tipoReporte={tipoReporte}
                    setTipoReporte={setTipoReporte}
                    cargando={cargando}
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    totalRecords={totalRecords}
                    pageNumber={pageNumber}
                    setPageNumber={setPageNumber}
                    idCatTipoUsuario={idCatTipoUsuario}
                    ObtenerOrden={ObtenerOrden}
                    searchFilter={searchFilter}
                    setSearchFilter={setSearchFilter}
                    onSearchChange={handleSearchChange}

                />
            ) : (
                <TablaDetalleOrdenes
                    detallesOrdenes={detallesOrdenes}
                    vendedores={vendedores}
                    vendedorID={vendedorID}
                    setVendedorID={setVendedorID}
                    dateQuarter={dateQuarter}
                    FilterEstatus={FilterEstatus}
                    setFilterEstatus={setFilterEstatus}
                    tipoReporte={tipoReporte}
                    setTipoReporte={setTipoReporte}
                    cargando={cargando}
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    totalRecords={totalRecords}
                    pageNumber={pageNumber}
                    setPageNumber={setPageNumber}
                    idCatTipoUsuario={idCatTipoUsuario}
                    ObtenerDetallesOrden={ObtenerDetallesOrden}
                    searchFilter={searchFilter}
                    setSearchFilter={setSearchFilter}
                    onSearchChange={handleSearchChange}

                />
            )}

            {cargando && (<h5><Spinner className="text-inline" animation="border" variant="primary" /> Cargando...</h5>)}
        </>
    );
};

export default CatalogoOrdenes;
